import styled from 'styled-components'

export const UserSignupWrapper = styled.div`
  height: 100%;
  background: ${({ theme }) => theme.colors.brand};
  background: ${({ theme }) => `linear-gradient(25deg, ${theme.colors.backgroundLite} 65%, ${theme.colors.brand} 130%)`};
`

export const UserSignupInnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`

export const UserSignupFormWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
`

export const UserSignupFormInnerWrapper = styled.div`
  max-width: 500px;
  width: 100%;
`

export const UserSignupFormContent = styled.div`
  padding: 40px;
  width: 100%;

  border-radius: 10px;
`

export const UserSignupLogoLink = styled.a`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  & svg {
    width: 150px;
    height: 50px;
    & path {
      fill: ${({ theme }) => theme.colors.primary};
    }
  }
`
export const UserSignupTitle = styled.h1`
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0 0 30px 0;
`

export const UserSignupBrandWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  min-height: 100vh;
`

export const UserSignupBottomWrapper = styled.div`
  align-self: center;

  //TODO: Style Variable
  color: ${({ theme }) => theme.colors.background};
`

export const PrivacyPolicyLink = styled.a`
  display: block;
  margin: 20px 0px 0px 0px;
  width: 100%;

  font-weight: 400;
  font-size: 12px;
  text-decoration: underline;
  text-align: center;

  color: ${({ theme }) => theme.colors.primary};
`

export const UserSignupFormFooterText = styled.p`
  display: flex;
  justify-content: flex-end;
  margin: 5px 0 0 0;

  font-size: 12px;
  color: ${({ theme }) => theme.colors.primary};
  text-align: right;
`

export const UserSignupFormFooterLink = styled.a`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primary};
`
